import { render, staticRenderFns } from "./Guanli.vue?vue&type=template&id=21e6b46e&scoped=true"
import script from "./Guanli.vue?vue&type=script&lang=js"
export * from "./Guanli.vue?vue&type=script&lang=js"
import style0 from "./Guanli.vue?vue&type=style&index=0&id=21e6b46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6b46e",
  null
  
)

export default component.exports